/* eslint-disable @typescript-eslint/no-explicit-any */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { Alert } from '../../types/AlertTypes'

export interface AlertState {
  alerts: Alert[] | undefined
  totalPages: number
  alertTableCurrentPage: number
}

const initialState: AlertState = {
  alerts: undefined,
  totalPages: 1,
  alertTableCurrentPage: 0,
}

export const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    setAlerts(state, action: PayloadAction<any>) {
      state.alerts = action.payload
    },
    setTotalPages(state, action: PayloadAction<any>) {
      state.totalPages = action.payload
    },
    setAlertTableCurrentPage(state, action: PayloadAction<any>) {
      state.alertTableCurrentPage = action.payload
    },
  },
})
export const selectAlerts = (state: RootState) => state.alerts

export const { setAlerts, setTotalPages, setAlertTableCurrentPage } = alertsSlice.actions
export default alertsSlice.reducer
